<template>
    <div :class="$style.root">
        <div class="box-newshot">
            <div class="box-news-videohot">
                <div class="title">热点视频 <span @click="toRecommend" class="more">更多</span></div>
                <!-- <newVideoView  :list='hotVideoList'/> -->
                <a-spin :spinning="spinning">
                    <div class="spin-content">
                        <div v-if="hotVideoList.length>0" style="">
                            <!--                            <div class="video-box"-->
                            <!--                                @click="goVideoDetail(item.media_id)"-->
                            <!--                                v-for="(item, index) in hotVideoList.slice(0,4)"-->
                            <!--                                :key="index">-->
                            <!--                                <div class="clear:both"></div>-->
                            <!--                                <div class="video-img">-->
                            <!--                                    <img :src="baseUrl+item.programId+'/thumbnail.png'" @error="defImg()" />-->
                            <!--                                </div>-->
                            <!--                                <div class="video-title">{{ item.media_name }}</div>-->
                            <!--                                <div class="video-info">-->
                            <!--                                    <div class="time">-->
                            <!--                                        <a-icon type="like" theme="filled" :style="{ fontSize: '16px', color: '#d8311b', backGround: '#d8311b' }" />  &nbsp;{{ item.like_count||0 }}-->

                            <!--                                        <a-icon-->
                            <!--                                            :style="{ fontSize: '16px', color: '#cdcdcd', backGround: '#cdcdcd' ,marginLeft:'10px'}"-->
                            <!--                                            type="video-camera" />&nbsp; &nbsp;{{ item.views||0 }}-->
                            <!--                                    </div>-->
                            <!--                                    <div class="play">{{ item.view_duration }}</div>-->
                            <!--                                </div>-->
                            <!--                                <div class="clear:both"></div>-->
                            <!--                            </div>    -->
                            <newVideoView :video-recommendedlist="hotVideoList" />


                        </div>

                        <div style="text-align:center;" v-else>暂无内容</div>
                        <div class="clear:both"></div>
                    </div>
                </a-spin>
                <div class="clear:both"></div>
            </div>
            <div class="clear:both"></div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import moment from 'moment';
    import newVideoView from '../../../components/newVideoView.vue';
    // import newVideoView from './newVideoView.vue';

    export default {
        name: 'NewHotView',
        components: { newVideoView },
        filters: {
            newformatTime(data) {
                const hours = moment.duration(parseInt(data, 0)).hours();


                const seconds = moment.duration(parseInt(data, 0)).seconds();

                const minutes = moment.duration(parseInt(data, 0)).minutes();

                return `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
            },
        },
        data() {
            return {
                spinning: true,
                baseUrl: '',
                defaultImg: require('@/assets/LOGO_bg.png'),
            };
        },
        computed: {
            ...mapState(['userInfo']),
            ...mapState('indexView', ['hotVideoList']),
        },
        mounted() {
            this.handleLoadList();
            const URL = `http://${window.location.host.split(':')[0]}:8000/`;
            this.baseUrl = URL;
        },
        methods: {
            ...mapActions('indexView', ['getHotVideoList']),
            ...mapActions('params', [
                'storageLiveParams',
            ]),
            // 加载列表
            handleLoadList() {
                let queries = {};
                // const _this = this;
                const orgId = this.userInfo.org_id || '';

                queries = {
                    orgId: orgId || '',
                    orderType: '2',
                };
                if (!this.userInfo.user_name) {
                    delete queries.orgId;
                }
                this
                    .getHotVideoList(queries)
                    .then(() => {
                        this.spinning = false;
                    })
                    .catch(({ message }) => {
                        if (message) this.$message.error(message);
                        this.spinning = false;
                    });
            },

            goVideoDetail(mediaId) {
                this.storageLiveParams({ mediaId });
                this.$router.push({ name: 'VideoDetailView', params: { mediaId } });
            },
            toRecommend() {
                this.$router.push({ name: 'RecommendView' });
            },
            defImg() {
                const img = event.srcElement;
                img.src = this.defaultImg;
                img.onerror = null; // 防止闪图
            },
        },
    };
</script>

<style lang="less" module>
    .root {
        width: 100%;

        /* height: 320px; */

        /* background: #f0f3f9; */
        margin-bottom: 20px;

        :global {
            .box-newshot {
                padding-top: 30px;
                max-width: 1200px;
                height: 320px;
                overflow: hidden;
                margin: auto;

                .title {
                    width: 100%;
                    height: 40px;
                    line-height: 40px;
                    font-size: 16px;
                    color: #435573;
                    margin-bottom: 10px;
                    padding-left: 10px;
                }
            }

            .video-box {
                width: 280px;
                margin: 0 10px 20px;
                //   margin-right: 20px;
                //   margin-bottom: 20px;
                height: 230px;
                float: left;
                cursor: pointer;
                overflow: hidden;
            }

            .video-box:hover {
                background: #f0f3f9;
                -moz-box-shadow: 0 0 10px #888; /* 老的 Firefox */
                box-shadow: 0 0 10px #888;
            }


            .video-img {
             width: 100%;
                height: 158px;
                overflow: hidden;
            }

            .video-img img {
                transition: all 0.6s;
                width: 100%;
                height: 158px;
            }

            .video-box:hover .video-img img {
                transform: scale(1.2);
            }


            .more {
                float: right;
                font-size: 12px;
                cursor: pointer;
            }

        }
    }
</style>
